import { useEffect } from 'react';
import { useStableCallback } from './useStableCallback';
export function useEventListener(element, type, userListener, options) {
    const stableListener = useStableCallback(userListener);
    useEffect(() => {
        if (!element)
            return;
        const listener = (...args) => {
            stableListener.apply(element, args);
        };
        const typeArr = Array.isArray(type) ? type : [type];
        typeArr.forEach((eventType) => {
            element.addEventListener(eventType, listener, options);
        });
        return () => {
            typeArr.forEach((eventType) => {
                element.removeEventListener(eventType, listener, options);
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [element, type]);
}
//# sourceMappingURL=useEventListener.js.map